// extracted by mini-css-extract-plugin
export default {"bold":"buttonOfCondition_bold__Cn-mK","button":"buttonOfCondition_button__TTUKU"};